<header role="banner">
  <toolbar></toolbar>
</header>
@if (!cssDisabled) {
  <spinner></spinner>
}
<router-outlet></router-outlet>
@if (!cssDisabled) {
  <alert-modal></alert-modal>
}
@if (!cssDisabled) {
  <confirm-modal></confirm-modal>
}
@if (!cssDisabled) {
  <notify-modal></notify-modal>
}
@if (!cssDisabled) {
  <warn-modal></warn-modal>
}
<go-footer></go-footer>